let offers;
let theProduct;
let cartRefreshPending = false;
let manualOp = false;

if(1) { // Removal of `window.MulberryVariant === 2`
  document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener("mulberry-shopify:loaded", async function (e) {
      window.mb_gtm_is_disabled = true
      await removeAndSyncWarranties();
      if (document.location.href.includes("/products/")) {
        initMulberry();
      } else if(window.location.pathname === '/cart') {
        await mulberryShop.cart.init();
        mulberryShop.cart.render();
      }
    
      let lastUrl = location.href;
    
      let theVariant;
      function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      }
        
      async function handleUrlChange() {
        var variant = getUrlParameter('variant');
        if (variant && theVariant !== variant && window.pdpInline) {
          theVariant = variant
    
          window.selectedOffer = null;
          window.pdpInline.deselectOffer();
          
          mulberryShop.selectedVariantId = variant
          selectedVariant = getCurrentlySelectedVariant(theProduct);
          offers = await mulberry.core.getWarrantyOffer({
            id: selectedVariant.id,
            title: theProduct.title,
            price: selectedVariant.price,
            detail: theProduct,
          });
    
          if(offers && offers.length) {
            document.querySelector('#mulberry-container').style.display = 'block';
            if (mulberry.core.settings.has_inline) {
              window.pdpInline.updateOffer(offers);
            }
            
            if (mulberry.core.settings.has_modal) {
              window.mulberry.modal.updateOffer(offers);
            }
          } else {
            document.querySelector('#mulberry-container').style.display = 'none';
          }
          if (!document.querySelector('.btn-prd').disabled) {
            document.querySelector('.btn-temp').disabled = false;
            document.querySelector('.btn-temp').querySelector('span').textContent = 'Add to cart'
          } else {
            document.querySelector('.btn-temp').disabled = true;
            document.querySelector('.btn-temp').querySelector('span').textContent = 'Sold out'
          }
          document?.querySelector(".btn-temp")?.addEventListener("click", function (e) {
            productAddClickHandler.call(this, e);
          });
        }
      }
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function() {
          if (lastUrl !== location.href) {
            lastUrl = location.href;
            handleUrlChange();
          }
        });
      });
    
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      setTimeout(() => {
        handleUrlChange();
      }, 5000)
    });
    
    document.addEventListener('mulberry-shopify:warranty-added', async function (e) {
      if (window.location.pathname.includes("/cart")) {
        await removeAndSyncWarranties();
        window.location.reload();
        return;
      } else {
        if(!manualOp) {
          await removeAndSyncWarranties();
        }
        manualOp = false;
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: !0,
            detail: {
              replacementDelay: 600,
            },
          })
        );
        let updatedCart = await fetch('/cart.json');
        updatedCart = await updatedCart.json();
        syncCartCountAndTotal(updatedCart.item_count, updatedCart.total_price);
        // await renderCart(true);
      }
  });
    document.addEventListener('click', async function (e) {
      if (e.target.closest('.header__icon-wrapper')) {
        if(e.target.getAttribute('aria-controls') === 'mini-cart') {
          // await renderCart(true);
        }
      } else if(e.target.closest('.btn-sticky-temp')) {
        productAddClickHandler.call(e.target.closest('.btn-sticky-temp'));
      }
    });
    document?.querySelector(".btn-temp")?.addEventListener("click", function (e) {
      productAddClickHandler.call(this, e);
  });
    document.addEventListener("updateCart", async function (event) {
      let newCart = event.detail;
      const content = event.detail;
    
      if (!window.location.pathname.includes("/cart")) {
        // newCart.sections = ["mini-cart"];
      }

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: !0,
          detail: {
            replacementDelay: 600,
          },
        })
      );
      
      syncCartCountAndTotal(content.item_count, content.total_price);
    
      // setTimeout(async () => {
      //   await renderCart(true);
      // }, 500);
    });
  });
} else {
  document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('click', async function (e) {
      if(e.target.closest('.btn-sticky-temp')) {
        productAddClickHandler.call(e.target.closest('.btn-sticky-temp'));
      }
    });
    document?.querySelector(".btn-temp")?.addEventListener("click", function (e) {
      productAddClickHandler.call(this, e);
    });
  });
}

function getCurrentlySelectedVariant(product) {
  selectedVariant = product.variants.find(
    (i) => i.id == mulberryShop.selectedVariantId
  );
  if (!selectedVariant) {
    selectedVariant = product.variants[0];
  }
  mulberryShop.selectedVariantId = selectedVariant.id;
  return selectedVariant;
}
async function getOffers() {
  const productData = await window.mulberryShop.getProductData(
    window.mulberryShop.getProductUrl()
  );
  product = productData.product;
  theProduct = productData.product;
  window.mulberryShop.selectedVariantId = window.selectedVariantId;
  window.selectedVariant = product.variants.find(
    (i) => i.id == window.mulberryShop.selectedVariantId
  );
  if (!window.selectedVariant) {
    window.selectedVariant = product.variants[0];
  }
  if (
    window.selectedVariant &&
    window.selectedVariant.id &&
    window.selectedVariant.price
  ) {
    return window.mulberry.core.getWarrantyOffer({
      detail: {...product, id: window.selectedVariant.id},
      title: product.title,
      id: window.selectedVariant.id,
      price: window.selectedVariant.price,
    });
  }
}
async function initMulberry() {

  window.offers = await getOffers();

  window.pdpInline =  await window.mulberry.inline.init({
    offers: window.offers,
    layout: {
      faq: true,
      logo: false,
      input: 'checkbox'

  	},
    settings: window.mulberry.core.settings,
    selector: "#mulberry-container",
    onWarrantyToggle: async (warranty) => {
      if (warranty.isSelected) {
        window.selectedWarranty = warranty;
        window.productForWarranty = product;
      } else {
        window.selectedWarranty = null;
        window.productForWarranty = null;
      }
    },
  });

  mulberry.faq.init({
    coverage: mulberry.core.offers[0],
    settings: mulberry.core.settings
  })
  setTimeout(() => {
    document.querySelector("#whats-covered-faq")?.removeAttribute("style")  
  }, 2000);
  document.querySelector("#whats-covered-faq")?.addEventListener("click",function(){
    mulberry.faq.open();
  });

  if(mulberry.core.settings.has_modal) {
    window.mulberryPDPModal = window.mulberry.modal.init({
      offers: window.offers,
      settings: window.mulberry.core.settings,
      onWarrantySelect: async (warranty) => {
        window.productForWarranty = product;
        const result = await window.mulberryShop.getWarrantyVariant(
          warranty
        );
        await window.mulberryShop.addWarrantyToCart(
          result.shopify_variant_id,
          {...product, variantId: `${window.selectedVariant.id}`, quantity: parseInt(document.querySelector('.quantity-selector__input').value)},
          warranty
        );
        window.selectedWarranty = null;
        document.querySelector(".btn-prd").click();
        document.querySelector(".btn-temp").removeAttribute('aria-busy');
        document.querySelector(".btn-temp").querySelector(".loader-button__loader").classList.add("hidden");
        window.mulberry.modal.close();
      },
      onWarrantyDecline: () => {
        document.querySelector(".btn-prd").click();
        document.querySelector(".btn-temp").removeAttribute('aria-busy');
        document.querySelector(".btn-temp").querySelector(".loader-button__loader").classList.add("hidden");
        mulberry.modal.close()
      }
    })
  }

  setupFetchListeners();
}
async function productAddClickHandler(e) {
  e = this;
  e.setAttribute('aria-busy', 'true');
  const spinner = e.querySelector(".loader-button__loader");
  if (spinner) {
    spinner.classList.remove("hidden");
  }
    
  if (
    window.selectedWarranty &&
    window.selectedWarranty != null
  ) {
    try {
      const result = await window.mulberryShop.getWarrantyVariant(
        window.selectedWarranty.offer
      );
      manualOp = true;
      await window.mulberryShop.addWarrantyToCart(
        result.shopify_variant_id,
        {...product, variantId: `${window.selectedVariant.id}`, quantity: parseInt(document.querySelector('.quantity-selector__input').value)},
        window.selectedWarranty.offer
      );
      window.selectedWarranty = null;
      window.mulberry.inline.deselectOffer();
    } catch (error) {
    } finally {
      document.querySelector(".btn-prd").click();
      e.removeAttribute('aria-busy');
      // setTimeout(async () => {
      //   await renderCart(true);  
      // }, 2000)
    }
  } else if(0) {
    window.mulberry.inline.deselectOffer();
    window.mulberry.modal.open()
    return null;
  } else {
    document.querySelector(".btn-prd").click();
    e.removeAttribute('aria-busy');
    // setTimeout(async () => {
    //   await renderCart(true);  
    // }, 2000)
  }
}
async function removeAndSyncWarranties(reload = false) {
  let response = await fetch('/cart.js', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  let firstCart = await response.json();
  const originalItemCount = firstCart.item_count;

  // Filter items
  firstCart.items = firstCart.items.filter(
    item => item?.properties?._variantId !== 'sectional'
  );

  try {
    const newCart = await mulberryShop.removeDetachedWarranty(firstCart);
    const updatedCart = await mulberryShop.cart.syncQuantities(newCart);

  } catch (error) {
    console.error('Error during warranty removal and cart sync:', error);
  }
}
const syncCartCountAndTotal = (itemCount, totalPrice) => {
  if (itemCount === 0) {
    if (window.location.pathname.includes("/cart")) {
      const cartTotal = document.querySelector(".cart__total-container")
        .lastElementChild.innerHTML;
      const actualTotal = `\$${(totalPrice / 100).toLocaleString(
        undefined,
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      )}`;
      if (actualTotal !== cartTotal) {
        window.location.reload();
      }
    } else {
      const checkoutButton = document.querySelector(".checkout-button");
      if (checkoutButton) {
        // fire off full cart refresh if there are 0 items but checkout button still present
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: !0,
            detail: {
              replacementDelay: 600,
            },
          })
        );
      }
    }
  } else {
    if (window.location.pathname.includes("/cart")) {
      if (document.querySelector(".cart__total-container")) {
        document.querySelector(
          ".cart__total-container"
        ).lastElementChild.innerHTML = `\$${(
          totalPrice / 100
        ).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      }
    } else {
      if (document.querySelector("cart-count")) {
        document.querySelector("cart-count").innerHTML = itemCount;
      }
      if (document.querySelector(".checkout-button")) {
        document.querySelector(
          ".checkout-button"
        ).innerHTML = `Checkout<span class="square-separator"></span>\$${(
          totalPrice / 100
        ).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      }

      if (document.querySelectorAll(".drawer__title")) {
        const itm = itemCount > 1 ? "items" : "item";
        document.querySelectorAll(".drawer__title").forEach((el) => {
          if (el && el.querySelector("span")) {
            el.querySelector(
              "span"
            ).innerHTML = `${itemCount} ${itm}`;
          }
        });
      }
    }
  }
};
const renderCart = async (force = false) => {
  setTimeout(async () => {
    const cartSlideout = document.querySelector("#mini-cart");
    if (cartSlideout && cartSlideout.hasAttribute("open")) { // Removal of  && window.MulberryVariant === 2 
      await mulberryShop.cart.init();
      mulberryShop.cart.render();
    }
  
    if (window.location.pathname.includes("/cart")) {
      window.location.reload();
    }
  }, 1200);
};
function setupFetchListeners() {
  const { fetch: origFetch } = window;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    let requestUrl = args[0];
    if (
      requestUrl.includes("cart/change") ||
      requestUrl.includes("cart/add") ||
      requestUrl.includes("cart/update")
    ) {
      response
        .clone()
        .json()
        .then(async (body) => {
          if (requestUrl.includes("cart/change")) {
            await removeAndSyncWarranties();
            let cartBody = await fetch('/cart.json')
            cartBody = await cartBody.json();
            const updateCart = new CustomEvent("updateCart", {
              detail: cartBody,
            });
            document.dispatchEvent(updateCart);
          }
        })
        .catch((err) => console.error(err));
    }
    return response;
  };
}